import { all } from 'redux-saga/effects';

import atualizarParametroLocalidadeSaga from './atualizarParametroLocalidade/saga';
import cadastrarParametroLocalidadeSaga from './cadastrarParametroLocalidade/saga';
import consultarParametrosLocalidadeSaga from './consultarParametrosLocalidade/saga';
import excluirParametroLocalidadeSaga from './excluirParametroLocalidade/saga';
import consultarParametroLocalidadeDetalheSaga from './consultarParametroLocalidadeDetalhe/saga';
import atualizarParametroLocalidadeDetalheSaga from './atualizarParametroLocalidadeDetalhe/saga';
import consultarParametrosLocalidadeV2Saga from './consultarParametrosLocalidadeV2/saga';
import consultarParametroLocalidadesSiglaSaga from './consultarParametroLocalidadesSigla/saga';
import excluirParametrosLocalidadeSaga from './excluirParametrosLocalidade/saga';

export default all([
	atualizarParametroLocalidadeSaga,
	cadastrarParametroLocalidadeSaga,
	consultarParametrosLocalidadeSaga,
	excluirParametroLocalidadeSaga,
	consultarParametroLocalidadeDetalheSaga,
	atualizarParametroLocalidadeDetalheSaga,
	consultarParametrosLocalidadeV2Saga,
	consultarParametroLocalidadesSiglaSaga,
	excluirParametrosLocalidadeSaga,
]);
